import { InjectedFormProps } from "redux-form";
import { Field } from "redux-form/immutable";

import { Alert, Box, Button, Heading, Link, Stack } from "@seneca/senekit";

import { FormTextInput } from "features/forms/components/FormTextInput";
import { linkToPasswordReset } from "features/sign-up/links";

type Props = {
  handleSubmit: () => void;
} & InjectedFormProps;

export function UpdatePasswordForm({
  handleSubmit,
  pristine,
  submitting,
  error
}: Props) {
  return (
    <Box paddingTop="large">
      <form onSubmit={handleSubmit}>
        <Stack space="xlarge">
          <Heading level="3">Change password</Heading>
          <div data-test="CurrentPassword">
            <Field
              name="currentPassword"
              component={FormTextInput}
              type="password"
              label="Current password"
            />
          </div>
          <div data-test="NewPassword">
            <Field
              name="newPassword"
              component={FormTextInput}
              type="password"
              label="New password"
            />
          </div>
          <div data-test="VerifyNewPassword">
            <Field
              name="verifyPassword"
              component={FormTextInput}
              type="password"
              label="Verify new password"
            />
          </div>

          <Button loading={submitting} disabled={pristine} onClick={() => {}}>
            Save
          </Button>

          <Link to={linkToPasswordReset()}>Forgot your password?</Link>

          {error && (
            <Alert iconName="exclamationCircle" tone="error">
              {error}
            </Alert>
          )}
        </Stack>
      </form>
    </Box>
  );
}
